import comp from "./AddPostDetails";
export default comp;
